import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

const state = {
  email: "",
};

const getters = {
  email: (state) => state.email,
};

const actions = {
  async requestResetLink({ commit }, { email, domain }) {
    commit("setEmail", email);

    return await $http.post(`${getApiClientUrl()}/v1/idp/password/forgot`, {
      domain,
      email,
    });
  },
  async setNewPassword(
    { commit },
    { email, password, confirm_password, token },
  ) {
    commit("setEmail", email);
    return await $http.post(`${getApiClientUrl()}/v1/idp/password/reset`, {
      email,
      password,
      confirm_password,
      token,
    });
  },
};

const mutations = {
  setEmail: (state, data) => (state.email = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
